import { useRequestDemoMutation } from '@/types/vue-apollo-helpers';
import type { RequestDemoInput, MutationResponse } from '@/types/composition-functions';

/** Public landing-page demo / sales enquiry. Throws on GraphQL errors. */
export function useRequestDemo() {
  const { mutate, loading } = useRequestDemoMutation();

  async function requestDemo(input: RequestDemoInput): Promise<MutationResponse | null> {
    const response = await mutate({ input });
    return response?.data?.requestDemo ?? null;
  }

  return { requestDemo, isSubmitting: loading };
}
